import React, { useState, useEffect } from "react";
import { FaTag, FaCalendarAlt, FaPlusCircle } from "react-icons/fa"; // Import icons from react-icons
import "../Styles/discountRules.css";
import BasicDeal from "../Components/BasicDeal";
import DiscountRulesLayout from "../Components/DiscountRulesLayout";
const DiscountRules = ({dialogBox, setDialogBox}) => {
  const [isLaptop, setIsLaptop] = useState(window.matchMedia("(min-width: 1024px)").matches);
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 768px)").matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1024px)");
    mediaQuery.addEventListener("change", handleResize);
    const mediaQueryList = window.matchMedia("(max-width: 768px)");
    mediaQueryList.addEventListener("change", updateScreenSize);
  }, []);

  const handleResize = (event) => {
    setIsLaptop(event.matches);
  };

  const updateScreenSize = (event) => {
    setIsMobile(event.matches);
  };

  return (
    <div>
          <p><strong>* Deal Modifications may take 12-24 hours to reflect</strong></p>
      {
        isMobile && (
        <div className="d-flex justify-content-center gap-4">
          <button style={{ fontSize: "0.7rem" }} className="bg-black text-white px-4 py-2 rounded shadow hover:bg-black-700 transition cursor-pointer" onClick={() => setDialogBox("basic-deal")}>
            Add Basic Deal
          </button>
          <button style={{ fontSize: "0.7rem" }} className="bg-black text-white px-4 py-2 rounded shadow hover:bg-black-700 transition cursor-pointer" onClick={() => setDialogBox("last-minute-deal")}>
            Add Last min. Deal
          </button>
          {dialogBox && (
            <DiscountRulesLayout
              activeDialog={dialogBox}
              setActiveDialg={setDialogBox}
            />
          )}
        </div>
        )
      }
    
      {
        isLaptop && (
          <div className="discount-rules-container">
        <div className="deal-cards">
          {/* Basic Deal Card */}
          <div className="deal-card">
            <div className="deal-icon">
              <FaTag size={24} />
            </div>
            <h3>Basic Deal</h3>
            <p>Recommended 10% discount or more</p>
            <p>Available for any dates</p>
            <button
              className="add-promotion-btn"
              onClick={() => setDialogBox("basic-deal")}
            >
              <FaPlusCircle size={16} /> Add Promotion
            </button>
          </div>



          {/* Last-Minute Deal Card */}
          <div className="deal-card">
            <div className="deal-icon">
              <FaCalendarAlt size={24} />
            </div>
            <h3>Last-Minute Deal</h3>
            <p>Recommended 10% discount or more</p>
            <p>Fill any empty rooms you have left</p>
            <button
              className="add-promotion-btn"
              onClick={() => setDialogBox("last-minute-deal")}
            >
              <FaPlusCircle size={16} /> Add Promotion
            </button>
          </div>


          {dialogBox && (
            <DiscountRulesLayout
              activeDialog={dialogBox}
              setActiveDialg={setDialogBox}
            />
          )}

        </div>
      </div>
        )
      }
    </div>
  );
};

export default DiscountRules;